import React, { useRef, useState } from "react";
import Avatar from "react-avatar";
import { IonButton } from "@ionic/react";
import styled from "styled-components";

import { ImageSelector } from "../../../file";

import strings from "../../../../res/strings";

const Container = styled.div``;

const ImageDisplay = styled.div`
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
`;
const AvatarContainer = styled.div`
  display: block;
  margin-left: 50px;
`;

const SaveButtonContainer = styled.div`
  padding: 4px 16px 4px 16px;
`;
const SaveButton = styled(IonButton)`
  font-size: 0.8em;
`;
const CancelButton = styled(IonButton)`
  font-size: 0.8em;
`;
const ImageDisplayActions = styled.div`
  display: flex;
  justify-content: center;
`;
const ImageDisplayActionButton = styled.div`
  font-size: 0.8em;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  text-decoration-line: underline;
  font-family: Secular One;
  font-style: normal;
  font-weight: normal;
  cursor: pointer;

  :hover {
    color: #666666;
  }
`;

const EditComponentContainer = styled.div`
  display: flex;
  justify-content: center;
  overflow: hidden;
  flex-direction: column;
`;

const EditableImage = (props) => {
  const avatarContainerRef = useRef(null);
  const [editing, setEditing] = useState(false);

  const handleCancel = (e) => {
    setEditing(false);
  };

  const handleClickData = (e) => {
    if (props.closeActiveFormEdit) {
      props.closeActiveFormEdit();
    }
    if (props.openActiveFormEdit) {
      props.openActiveFormEdit(handleCancel);
    }
    setEditing(true);
  };

  const imageDisplay = (
    <ImageDisplay>
      <AvatarContainer ref={avatarContainerRef}>
        <Avatar
          src={props.imageSource}
          name={props.imageAlternateString}
          round={true}
          size={125}
          style={{ cursor: "pointer" }}
        />
        {/* <OverlayContainer>
          <OverlayText>{strings.lib_common_action_change_click}</OverlayText>
        </OverlayContainer> */}
        <ImageDisplayActions>
          <ImageDisplayActionButton onClick={handleClickData}>
            EDIT AVATAR
          </ImageDisplayActionButton>
          {/* <ImageDisplayActionDivider>|</ImageDisplayActionDivider>
          <ImageDisplayActionButton>VIEW</ImageDisplayActionButton> */}
        </ImageDisplayActions>
      </AvatarContainer>
    </ImageDisplay>
  );

  const editComponent = (
    <EditComponentContainer>
      <ImageSelector
        selectedImages={props.selectedImages}
        setSelectedImages={props.setSelectedImages}
        maxFiles={props.maxFiles}
      />
      <SaveButtonContainer>
        <SaveButton type="submit" color="tertiary">
          {strings.lib_common_action_save}
        </SaveButton>
        <CancelButton color="danger" onClick={handleCancel}>
          {strings.lib_common_action_cancel}
        </CancelButton>
      </SaveButtonContainer>
    </EditComponentContainer>
  );

  return <Container>{editing ? editComponent : imageDisplay}</Container>;
};

export default EditableImage;
